import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { map } from 'rxjs';
import { watchCookie$ } from 'src/app/core/cookie-utils';
import { FeatureToggleService } from 'src/app/core/services/feature/feature-toggle.service';
import {
  FeatureTogglesDialog,
  FeatureTogglesDialogData,
} from './feature-toggles-dialog/feature-toggles-dialog.component';

@Component({
  selector: 'app-dev-mode',
  imports: [MatDialogModule],
  template: `@if (shouldShow()) {
    <span class="wrapper" (click)="onClick()">devmode</span>
  }`,
  styleUrl: './dev-mode.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevModeComponent {
  readonly shouldShow = toSignal(watchCookie$('devModeEnable').pipe(map(toBooleanStrict)));
  readonly #dialog = inject(MatDialog);
  readonly #featureToggleService = inject(FeatureToggleService);

  onClick() {
    this.#dialog.open<FeatureTogglesDialog, FeatureTogglesDialogData>(FeatureTogglesDialog, {
      data: {
        input: { featureFlags$: this.#featureToggleService.allToggles$ },
        output: { onOverrideChangeEventHandler: flag => this.#featureToggleService.toggleOverride(flag) },
      },
      width: '400px',
    });
  }
}

function toBooleanStrict(value: string | undefined): boolean {
  return value === 'true' || value === '1';
}
